import Types from '../types';

export function onProfileObjChange(profileObj) {
  return { type: Types.PROFILEOBJ, profileObj: profileObj };
}

export function onHistoryObjChange(historyObj) {
  return { type: Types.HISTORYOBJ, historyObj: historyObj };
}

export function onAuthorizationChange(authorization) {
  return { type: Types.AUTHORIZATION, authorization: authorization };
}

export function onSubscriptionChange(subscription) {
  return { type: Types.SUBSCRIPTION, subscription: subscription };
}

export function onOpenToolsPurchase(toolsModal) {
  return { type: Types.OPENTOOLSMODAL, toolsModal: toolsModal };
}

export function onOpenLeaveDialog(openLEave) {
  return { type: Types.OPENLEAVE, openLeave: openLEave };
}

export function getAllSubscription(allSubscription) {
  return { type: Types.ALLSUBSCRIPTION, allSubscription: allSubscription };
}

export function onOpenPack(openPack) {
  return { type: Types.OPENPACK, openPack: openPack };
}
